import defaultCard from '@/constants/instalationPassport/defaultCard'

export default defaultCard
